import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { useFormatter } from 'js/hooks/useFormatter';
import { useGetGoldenChipsBalances } from 'js/hooks/socket/hooks';

export const useGetTotalGoldenChipsBalance = () => {
    const formatter = useFormatter();
    const translate = useTranslations();
    const getGoldenChipsBalances = useGetGoldenChipsBalances();

    return useCallback(async (): Promise<string> => {
        try {
            const { data: { goldenChipsBalances } } = await getGoldenChipsBalances();

            if (!goldenChipsBalances?.length) {
                return formatter.formatCurrency(0);
            }

            const { currencyCode } = goldenChipsBalances[0].goldenChipValue || {};
            const amount = goldenChipsBalances
                .reduce((acc, balance) =>
                    acc + Number(balance.goldenChipValue?.amount || 0) * (balance.goldenChipsCount || 0), 0);

            return currencyCode === 'XXX'
                ? `${amount}`
                : formatter.formatCurrency(amount, { currencyCode });
        } catch {
            return translate('playtech.mobile.system.totalGoldenChipsBalance.error');
        }

    }, [getGoldenChipsBalances, formatter, translate]);
};
